<template>
  <div class="border rounded-lg flex flex-col" :class="[overflow, bgColor]">
    <div :class="{ 'divide-y': showSeparator }">
      <!-- an optional header element -->
      <div v-if="$slots.header">
        <slot name="header" />
      </div>

      <!-- Content -->
      <div v-if="$slots.default" :class="[contentWrapperClass]">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bgColor: { type: String, default: '' },
    overflow: { type: String, default: 'overflow-hidden' },
    contentWrapperClass: { type: String, default: null },
    showSeparator: { type: Boolean, default: true },
  },
}
</script>
